import { render, staticRenderFns } from "./YAxisSelectorAntV.vue?vue&type=template&id=3ad2ef70&scoped=true&"
import script from "./YAxisSelectorAntV.vue?vue&type=script&lang=js&"
export * from "./YAxisSelectorAntV.vue?vue&type=script&lang=js&"
import style0 from "./YAxisSelectorAntV.vue?vue&type=style&index=0&id=3ad2ef70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad2ef70",
  null
  
)

export default component.exports